import core from '@gvdasa/gv-core';
import { AxiosInstance } from 'axios';
import { Environment } from '../../environment';

const Api = core.GVHttpClient(Environment) as unknown as AxiosInstance;

export { Api };
